<template>
	<nav class="menu fixed column" :class="{ 'collapsed-menu': isCollapsed }">
		<ul class="menu-list head">
			<li>
				<router-link
					active-class="is-active" :to="`/${currentLang}/`" exact
				><img v-if="!isCollapsed" src="@/assets/logo.svg"/>
					<img
						class="logo-offset"
						v-if="isCollapsed"
						src="@/assets/logo.small.png"
					/></router-link>
			</li>
		</ul>
		<span
			v-if="!isMobile"
			class="collapse-button"
			:class="{ collapsed: isCollapsed }"
			@click="toggleCollapsed"
		><i
			class="fas"
			:class="isCollapsed ? 'fa-arrow-right' : 'fa-arrow-left'"
		></i
		></span>
		<p class="menu-label" v-if="!isCollapsed">{{ $t('sidemenu.general') }}</p>
		<p class="menu-label filler" v-else></p>
		<ul class="menu-list">
			<li>
				<router-link
					class="dashboard-router-link" active-class="is-active" :to="`/${currentLang}/`" exact
				><span
						class="icon dashboard-icon-container" :class="{ collapsed: isCollapsed }"
					>
						<div class="dashboard-icon">
							<div class="dashboard-icon__square"></div>
							<div class="dashboard-icon__square"></div>
							<div class="dashboard-icon__square"></div>
							<div class="dashboard-icon__square"></div>
						</div>
					</span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.dashboard') }}</span></router-link
				>
			</li>
			<li>
				<router-link
					active-class="is-active" :to="`/${currentLang}/statistics`" exact
				><span
						class="icon" :class="{ collapsed: isCollapsed }"
					><i
						class="fas fa-chart-bar"
					/></span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.statistics') }}</span></router-link
				>
			</li>
			<li v-if="$isAllowedTo('users_access_view')">
				<router-link
					active-class="is-active" :to="`/${currentLang}/users`" exact
				><span
						class="icon" :class="{ collapsed: isCollapsed }"
					><i
						class="fas fa-user-friends"
					/></span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.employees') }}</span></router-link
				>
			</li>
			<li v-if="$isAllowedTo('buildings_access_view')">
				<router-link
					:class="buildingsActive" :to="`/${currentLang}/buildings`"
				><span
					class="icon" :class="{ collapsed: isCollapsed }"
				><i class="fas fa-home" /> </span
				><span v-if="!isCollapsed">{{ $t('sidemenu.buildings') }}</span></router-link
				>
			</li>
			<li v-if="$isAllowedTo('documents_access_view')">
				<router-link
					active-class="is-active" :to="`/${currentLang}/documents`"
				><span
					class="icon" :class="{ collapsed: isCollapsed }"
				><i class="fas fa-file-alt" /> </span
				><span v-if="!isCollapsed">{{ $t('sidemenu.documents') }}</span></router-link
				>
			</li>
		</ul>
		<p v-if="showAdminSection && !isCollapsed" class="menu-label">{{ $t('sidemenu.admin') }}</p>
		<p v-if="showAdminSection && isCollapsed" class="menu-label divider"></p>
		<ul v-if="showAdminSection" class="menu-list">
			<li v-if="$isAllowedTo('licenses_access_view')">
				<router-link
					active-class="is-active" :to="`/${currentLang}/license`" exact
				><span
						class="icon" :class="{ collapsed: isCollapsed }"
					><i
						class="fas fa-id-card"
					/></span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.licenses') }}</span></router-link
				>
			</li>
			<li v-if="$isAllowedTo('apikeys_access_view')">
				<router-link
					active-class="is-active" :to="`/${currentLang}/apikeys`" exact
				><span
						class="icon" :class="{ collapsed: isCollapsed }"
					><i
						class="fas fa-key"
					/></span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.apikeys') }}</span></router-link
				>
			</li>
			<li v-if="$isAllowedTo('roles_access_view')">
				<router-link
					active-class="is-active" :to="`/${currentLang}/roles`" exact
				><span
						class="icon" :class="{ collapsed: isCollapsed }"
					><i
						class="fas fa-tags"
					/></span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.roles') }}</span></router-link
				>
			</li>
			<li v-if="$isAllowedTo('roundplannings_access_view')">
				<router-link
					active-class="is-active" :to="`/${currentLang}/roundplanning`"
				><span
						class="icon" :class="{ collapsed: isCollapsed }"
					><i
						class="fas fa-columns"
					/></span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.roundplanning') }}</span></router-link
				>
			</li>
			<li v-if="$isAllowedTo('checklists_access_view')">
				<router-link
					:class="checklistsActive" :to="`/${currentLang}/checklists`" exact
				><span
						class="icon" :class="{ collapsed: isCollapsed }"
					><i
						class="fas fa-tasks"
					/></span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.checklists') }}</span></router-link
				>
			</li>
			<li v-if="$isAllowedTo('questions_access_view')">
				<router-link
					active-class="is-active" :to="`/${currentLang}/questions`"
				><span
						class="icon" :class="{ collapsed: isCollapsed }"
					><i
						class="fas fa-question-circle"
					/></span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.questions') }}</span></router-link
				>
			</li>
			<li v-if="$isAllowedTo('fireprotections_access_view')">
				<router-link
					active-class="is-active" :to="`/${currentLang}/fireprotection`" exact
				><span
						class="icon" :class="{ collapsed: isCollapsed }"
					><i
						class="fas fa-fire-extinguisher"
					/></span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.fireprotection') }}</span></router-link
				>
			</li>
			<!-- Change this to correct -->
			<li v-if="$isAllowedTo('fireprotections_access_view')"> 
				<router-link
					:class="moveBuildingsActive" :to="`/${currentLang}/OngoingMoves`" exact
				><span
						class="icon" :class="{ collapsed: isCollapsed }"
					><i
						class="fas fa-building"
					/></span>
					<span v-if="!isCollapsed">{{ $t('sidemenu.buildingMoves') }}</span></router-link
				>
			</li>
		</ul>
		<router-link v-if="$isAllowedTo('changelogs_access_view')" class="versionnumber" :to="`/${currentLang}/changelog`">v{{ version }}</router-link>
		<p v-else class="versionnumber">v{{ version }}</p>
		<ul class="menu-list logout" v-if="isMobile">
			<li>
				<a
					@click="logout"
				><span class="icon"><i class="fas fa-sign-out-alt"/></span>
					<span>{{ $t('sidemenu.logout') }}</span></a
				>
			</li>
		</ul>
	</nav>
</template>

<script>
import { version } from '../../package.json';
import { mapGetters, mapActions } from 'vuex';
export default {
	data: () => ({
		version: ''
	}),

	computed: {
		...mapGetters('appStore', ['isMobile', 'isCollapsed']),
		currentLang() {
			return this.$route.params.lang || 'sv';
		},
		showAdminSection() {
			return [
				this.$isAllowedTo('licenses_access_view'),
				this.$isAllowedTo('fireprotections_access_view'),
				this.$isAllowedTo('roundplannings_access_view'),
				this.$isAllowedTo('checklists_access_view'),
				this.$isAllowedTo('apikeys_access_view'),
				this.$isAllowedTo('questions_access_view'),
				this.$isAllowedTo('roles_access_view')
			].some(value => value);
		},

		buildingsActive() {
			return this.$route.path.includes('buildings') || this.$route.path.includes('floor') ? 'is-active' : '';
		},

		checklistsActive() {
			return this.$route.path.includes('checklist') ? 'is-active' : '';
		},
		
		moveBuildingsActive() {
			return this.$route.path.includes('OngoingMoves') || this.$route.path.includes('MoveWizard') ? 'is-active' : '';
		}
	},

	methods: {
		...mapActions('appStore', ['toggleCollapsed']),
		logout() {
			this.$emit('logout');
		}
	},

	mounted() {
		this.version = version;
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";
@import "@/assets/colors.scss";

.menu.fixed {
  position: fixed;
  background-color: $light;
  height: 100%;
  min-width: $menu-width;
  max-width: $menu-width;
  z-index: 10;
  max-height: 100%;
  padding: 0;
  border-right: 0.1rem solid $dark;
  left: 0;
  top: 0;
  &.collapsed-menu {
    max-width: $menu-collapsed-width;
    min-width: $menu-collapsed-width;
  }
}
.menu-list.head {
  background-color: $dark;
  height: $navbar-height;
  margin-right: -1px;
  li a {
    padding: 0px;
    img {
      margin-left: 14px;
      margin-top: 7px;
      height: 34px;
      &.logo-offset {
        margin-left: 10px;
      }
    }
  }
}
.menu-list.head a {
  color: $white;
  font-size: 15px;
  padding-top: 11px;
}
.menu-list.head a:hover {
  background-color: $dark;
  color: $white;
}
.menu-list.head a.is-active {
  background-color: $dark;
  color: $white;
}
p.menu-label {
  margin-left: 10px;
  color: $white;
  &.filler {
    height: 18px;
  }
  &.divider {
    height: 18px;
    border-top: 1px solid #292c31;
    margin-right: 10px;
  }
}
p.menu-label:not(:last-child) {
  margin-bottom: 5px;
}
p.menu-label:not(:first-child) {
  margin-top: 15px;
}
.menu:not(.absolute) .menu-list:not(.head):not(.logout) li:last-child {
  margin-bottom: 35px;
}
.menu-list li a {
  padding-top: 8px;
  padding-bottom: 8px;
  color: $white;
  font-size: 13px;
  border-radius: 0;
}
.menu-list:not(.head) li a:hover {
  background-color: $info;
  color: $white;
}
.menu-list:not(.head) li a.is-active {
  background-color: $info-active;
}
.menu-list:not(.head) li a.is-active i,
.menu-list:not(.head) li a:hover i {
  color: $white;
}
.menu-list:not(.head) li a.is-active:hover {
  background-color: $info;
}
li .icon {
  margin-right: 10px;
  margin-left: 10px;
  width: 0.5rem;
  &.collapsed {
    margin-left: 0;
  }
}
li a:not(.is-active):not(:hover) i {
  color: $info-active;
}
.menu-list.logout {
  position: absolute;
  bottom: 0px;
  width: 100%;
  background: $dark;

  > li a {
    padding-left: 24px;
  }
}

.collapse-button {
  position: absolute;
  right: 10px;
  top: 54px;
  width: 24px;
  height: 24px;
  padding: 2px;
  cursor: pointer;
  text-align: center;
  &:hover i {
    color: $info;
  }
  &.collapsed {
    right: 14px;
  }
}

.versionnumber {
  position: absolute;
  bottom: 3rem;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-size: 13px;
  color: white;
}

a.dashboard-router-link {
	display: flex;
	align-items: center;

	&.is-active {
		.dashboard-icon__square {
			background: $white !important;
		}
	}

	&:hover {
		.dashboard-icon__square {
			background: $white !important;
		}
	}

	

	.dashboard-icon {
		display: grid;
		grid-template-columns: 6px 5px 2px 5px 6px;
		width: 24px;

		&-container {
			display: flex;
			justify-content: center;

			&:hover {
				.dashboard-icon__square {
					background: white;
				}
			}
		}

		> .dashboard-icon__square {
			width: 5px;
			height: 5px;
			margin-bottom: 2px;
			border-radius: .5px;
			background: $info;

			&:nth-child(odd) {
				grid-column-start: 2;
			}

			&:nth-child(even) {
				grid-column-start: 4;
			}
		}
	}
}
</style>
